import http from './api'

const route = '/recepcaoproduto/'

export default {

    listar: (empresaId, produtoId, produtorId, mes, ano, cpf) => {
        return http.post(route + 'listar_por_chave_mes_ano', {
            produto_id: produtoId,
            produtor_id: produtorId,
            empresa_id: empresaId,
            mes: mes,
            ano: ano,
            cpf: cpf,

        })
    },
    listarLaticinios: (chaveativacao) => {
        return http.post(route + 'listar_empresas', { chaveativacao: chaveativacao })
    },

    listarProdutos: (chaveativacao, idProdutor) => {
        return http.post(route + 'listar_produtos', {
            chaveativacao: chaveativacao,
            produtor: idProdutor,
        })
    },

    listarGrafico: (chaveativacao, empresaId, produtorId) => {
        return http.post(route + 'listar_grafico', { chaveativacao: chaveativacao, empresa_id: empresaId, produtor_id: produtorId })
    },
    listarPropriedades: (chaveativacao) => {
        return http.post(route + 'listar_propriedades', { chaveativacao: chaveativacao })
    },
}
